<template>
  <div>
    <!-- bk settings -->
    <p class="title is-5">BK settings</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Point</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="bkSettings.client.point" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Profile</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="bkSettings.client.profile" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Channel</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="bkSettings.client.channel" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>


    <div class="field is-horizontal">
      <div class="field-label">
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            <button @click="save" class="button is-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import bkService from '../../../../services/bk.service';

  export default {
    name: 'client-settings-bk',
    data() {
      return {
        bkSettings: {
          server: {},
          client: {}
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      this.bkSettings = await bkService.getSettingsByClient(this.clientId);
    },
    methods: {
      async save() {
        await bkService.save(this.clientId, this.bkSettings);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/bk.vue